import {SpinnerSubtextDefaultBox} from "./spinner-subtext.default.box";

export const SpinnerSubtextBox = SpinnerSubtextDefaultBox;